require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-cross-pollination-dev.json") })
        }
      }, "path---blog-cross-pollination-dev");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-cross-pollination-dev!./.cache/json/blog-cross-pollination-dev.json
// module id = 820
// module chunks = 231608221292675